import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate  } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Home from "../Home";
import Breadcrumb from "../../components/Breadcrumb";
import { Steps, Button, Select } from "antd";
import { getPersonCustomerDetails } from "./actions";
import { Modal, Spinner } from "react-bootstrap";
import {
  customerRequestDetails,
  resubmitChangeRequest,
  editChangeRequest,
} from "../CustomerRequestStatus/actions";
import { personAttributeChange } from "./actions";
import { getCustomerCode } from "../NewCustomerRequest/actions";
import { getOrganizationInquiryList } from "../OrganizationCustomer/actions";
import Maintenance from "../Maintenance";

const { Step } = Steps;
const { Option, OptGroup } = Select;
const RESIDENT_DOCTOR_ROLE = "研修医"; // Resident doctor role identifier

/*** 
@purpose : Functional component
@Parameter : {props}
**/
function PersonAttributeChange(props) {
  const navigate = useNavigate();
  const [current, setCurrent] = useState(0);
  const [showMessage, setShowMessage] = useState("");
  const [lang] = useTranslation("language");
  const [data, setData] = useState({});
  const [errors, setErrors] = useState({});
  const [path, setPath] = useState("");
  const [active, setActive] = useState("esearch-box lg-box");
  const [customerId, setCustomerId] = useState("");
  const [dataPartition, setDataPartition] = useState("");
  const [submissionId, setSubmissionId] = useState("");
  const [submissionType, setSubmissionType] = useState("");
  const [personId, setPersonId] = useState("");
  const [customerTypeId, setCustomerTypeId] = useState("");
  const [customerTypeName, setCustomerTypeName] = useState("");
  const [kanjiFacilityName, setKanjiFacilityName] = useState("");
  const [kanaFacilityName, setKanaFacilityName] = useState("");
  const [prefectureID, setPrefectureID] = useState("");
  const [prefecture, setPrefecture] = useState("");
  const [associationId, setAssociationId] = useState("");
  const [associationName, setAssociationName] = useState("");
  const [graduatedYear, setGraduatedYear] = useState("");
  const [registeredYear, setRegisteredYear] = useState("");
  const [graduatedYearDate, setGraduatedYearDate] = useState();
  const [registeredYearDate, setRegisteredYearDate] = useState();
  const [unifiedCustomerCode, setUnifiedCustomerCode] = useState("");
  const [legacyUnifiedCustomerCode, setLegacyUnifiedCustomerCode] =
    useState("");
  const [orgUnifiedCustomerCode, setOrgUnifiedCustomerCode] = useState("");
  const [genderId, setGenderId] = useState("");
  const [genderName, setGenderName] = useState("");
  const [universityId, setUniversityId] = useState("");
  const [universityName, setUniversityName] = useState("");
  const [remarks, setRemarks] = useState("");
  const [department, setDepartment] = useState("");
  const [role, setRole] = useState("");
  const [kanjiCustomerName, setKanjiCustomerName] = useState("");
  const [kanaCustomerName, setKanaCustomerName] = useState("");
  const [universityRole, setUniversityRole] = useState("");
  const [hospitalStatus, setHospitalStatus] = useState(0);
  const [customerCode, setCustomerCode] = useState();
  const [representativeCode, setRepresentativeCode] = useState("");
  const [representativeName, setRepresentativeName] = useState("");
  const [reApplicationCode, setReApplicationCode] = useState("");
  const [departmentId, setDepartmentId] = useState("");
  const [departmentName, setDepartmentName] = useState("");
  const [roleId, setRoleId] = useState("");
  const [roleName, setRoleName] = useState("");
  const [universityRoleId, setUniversityRoleId] = useState("");
  const [universityRoleName, setUniversityRoleName] = useState("");
  const [isUltmarcPharmacist, setIsUltmarcPharmacist] = useState(0);
  const [speciality, setSpeciality] = useState("");
  const [requestSubmissionId, setRequestSubmissionId] = useState("");
  const [personNotice, setPersonNotice] = useState("");
  const [noData, setNoData] = useState("");
  const [orgId, setOrgId] = useState("");
  const [maintenance, setMaintenance] = useState(false);
  const [loading, setLoading] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [resultLoading, setResultLoading] = useState(false);
  const [customerErrors, setCustomerErrors] = useState({});
  const [specialityList, setSpecialityList] = useState([]);
  const [personErrors, setPersonErrors] = useState({});
  const [specialities, setSpecialities] = useState([]);
  const [newSpecialityList, setNewSpecialityList] = useState([]);
  const [selectedSpecialities, setSelectedSpecialities] = useState([]);
  const [customerTypeList, setCustomerTypeList] = useState([]);
  const [genderList, setGenderList] = useState([]);
  const [prefectureList, setPrefectureList] = useState([]);
  const [universityList, setUniversityList] = useState([]);
  const [representativeList, setRepresentativeList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [roleList, setRoleList] = useState([]);

  const [dropdownList, setDropdownList] = useState([]);
  const routes = [
    {
      name: `${lang("Menu.home")}`,
      path: "/",
    },
    {
      name: `${lang("Menu.personCustomer")}`,
      path: "/personCustomer",
    },
    {
      name: `${lang("personDetails.personCustomerChangeRequest")}`,
      path: "",
    },
  ];

  useEffect(() => {
    async function fetchPersonData() {
      try {
        document.body.classList.add("sidebar-open");
        goBack();
        let id;
        let path;
        let pathname = window.location.pathname;
        path = unescape(pathname).split("/")[1];
        setPath(path);
        let url = window.location.href;
        id = unescape(url).split("?personId=")[1];
    const perCustType = sessionStorage.getItem("Person customer type");
    const prefecture = sessionStorage.getItem("Prefecture");
    const universityList = sessionStorage.getItem("University list");
    const genderList = sessionStorage.getItem("Gender list");
    const roleList = sessionStorage.getItem("Role");
    const departmentList = sessionStorage.getItem("Department");
    const speciality = sessionStorage.getItem("Speciality");
    setCustomerTypeList(JSON.parse(perCustType));
    setPrefectureList(JSON.parse(prefecture));
    setUniversityList(JSON.parse(universityList));
    setGenderList(JSON.parse(genderList));
    setUniversityList(JSON.parse(universityList));
    setRoleList(JSON.parse(roleList));
    setDepartmentList(JSON.parse(departmentList));
    setSpecialityList(JSON.parse(speciality));
    if (path === "personAttributeChange") {
      await props.getPersonCustomerDetails(id).then((res) => {
        if(res.maintenanceWindowFlag) {
          setMaintenance(true)
        }
        setIsLoading(false);
        setData(res[0]);
        let {
          perCustID,
          unifiedCustomerCode,
          customerType,
          facilityNameKanji,
          facilityNameKana,
          gender,
          birthPlaceStateProvince,
          regionalDoctorAssociation,
          graduatedUniversity,
          graduatedYear,
          registeredYear,
          customerSpecialities,
          remarks,
          org_unified_customer_code,
          legacyUnifiedCustomerCode,
          affiliated_department_name_local,
          job_title_name,
          uni_jt_name,
          hospital_owner_flag,
          ultmarc_pharmacist_flag,
        } = res;
        if (customerSpecialities && customerSpecialities.length > 0) {
          let newState = [];
          for (let index = 0; index < customerSpecialities.length; index++) {
            const serviceOne = customerSpecialities[index];
            newState.push({
              value: serviceOne.medicalSpecialityID,
              label: serviceOne.medical_speciality_name_local,
            });
          }
          setSpecialities(newState);
        }
        getCustomerTypeCode(customerType[0].custTypeID);
        setPersonId(perCustID ? perCustID : "");
        setUnifiedCustomerCode(unifiedCustomerCode ? unifiedCustomerCode : "");
        setCustomerTypeId(
          customerType && customerType[0].custTypeID
            ? customerType[0].custTypeID
            : ""
        );
        setCustomerTypeName(
          customerType && customerType[0].customerTypeNameLocal
            ? customerType[0].customerTypeNameLocal
            : ""
        );
        setKanjiFacilityName(facilityNameKanji ? facilityNameKanji : "");
        setKanaFacilityName(facilityNameKana ? facilityNameKana : "");
        setPrefectureID(
          birthPlaceStateProvince && birthPlaceStateProvince[0].stateID
            ? birthPlaceStateProvince[0].stateID
            : ""
        );
        setPrefecture(
          birthPlaceStateProvince && birthPlaceStateProvince[0].stateName
            ? birthPlaceStateProvince[0].stateName
            : ""
        );
        setAssociationId(
          regionalDoctorAssociation && regionalDoctorAssociation[0].stateID
            ? regionalDoctorAssociation[0].stateID
            : ""
        );
        setAssociationName(
          regionalDoctorAssociation && regionalDoctorAssociation[0].stateName
            ? regionalDoctorAssociation[0].stateName
            : ""
        );
        setGenderId(gender && gender.key ? gender.key : "");
        setGenderName(gender && gender.value ? gender.value : "");
        setUniversityId(
          graduatedUniversity && graduatedUniversity[0].uniID
            ? graduatedUniversity[0].uniID
            : ""
        );
        setUniversityName(
          graduatedUniversity && graduatedUniversity[0].uniName
            ? graduatedUniversity[0].uniName
            : ""
        );
        setGraduatedYear(graduatedYear ? graduatedYear : "");
        setRegisteredYear(registeredYear ? registeredYear : "");
        setRemarks(remarks);
        setDepartment(affiliated_department_name_local);
        setRole(job_title_name);
        setUniversityRole(uni_jt_name);
        hospital_owner_flag === "0" && setHospitalStatus(0);
        hospital_owner_flag === "1" && setHospitalStatus(1);
        hospital_owner_flag === null && setHospitalStatus(0);
        setLegacyUnifiedCustomerCode(legacyUnifiedCustomerCode);
        setIsUltmarcPharmacist(ultmarc_pharmacist_flag === "1" ? 1 : 0);
      });
    } else if (
      path === "personRequestResubmit" ||
      path === "personRequestEdit"
    ) {
      let body = {
        id: id,
      };
      await customerRequestDetails(body).then((res) => {
        if(res.maintenanceWindowFlag){
          setMaintenance(true);
        }
        if (res.data) {
          setIsLoading(false);
          let {
            submission_id,
            submission_type,
            unified_customer_code,
            lagacy_unified_customer_code,
            customer_id,
            customer_type,
            name_kanji,
            name_kana,
            gender,
            birth_place,
            doctor_pharmacist_association,
            graduated_university,
            graduated_year,
            registered_year,
            data_partition,
            specialities,
            affiliated_organization_customer_code,
            affiliated_department,
            role,
            university_role,
            hospital_owner,
            ultmarc_pharmacist_flag,
            remarks,
            ultmarc_reception_code,
          } = res.data;
          let newState = [];
          for (let index = 0; index < specialities.value.length; index++) {
            const serviceOne = specialities.value[index];
            newState.push({
              value: serviceOne.specialityID,
              label: serviceOne.specialityName,
            });
          }
          getCustomerTypeCode(customer_type.key);
          setSpecialities(newState);
          setSubmissionId(
            submission_id && submission_id.value ? submission_id.value : ""
          );
          setSubmissionType(
            submission_type && submission_type.value
              ? submission_type.value
              : ""
          );
          setSpecialities(newState);
          setUnifiedCustomerCode(
            unified_customer_code && unified_customer_code.value
              ? unified_customer_code.value
              : ""
          );
          setLegacyUnifiedCustomerCode(
            lagacy_unified_customer_code && lagacy_unified_customer_code.value
              ? lagacy_unified_customer_code.value
              : ""
          );
          setCustomerId(
            customer_id && customer_id.value ? customer_id.value : ""
          );
          setCustomerTypeId(
            customer_type && customer_type.key ? customer_type.key : ""
          );
          setCustomerTypeName(
            customer_type && customer_type.value ? customer_type.value : ""
          );
          setKanjiFacilityName(
            name_kanji && name_kanji.value ? name_kanji.value : ""
          );
          setKanaFacilityName(
            name_kanji && name_kana.value ? name_kana.value : ""
          );
          setPrefectureID(
            birth_place && birth_place.key ? birth_place.key : ""
          );
          setPrefecture(
            birth_place && birth_place.value ? birth_place.value : ""
          );
          setAssociationId(
            doctor_pharmacist_association && doctor_pharmacist_association.key
              ? doctor_pharmacist_association.key
              : ""
          );
          setAssociationName(
            doctor_pharmacist_association && doctor_pharmacist_association.value
              ? doctor_pharmacist_association.value
              : ""
          );
          setGenderId(gender && gender.key ? gender.key : "");
          setGenderName(gender && gender.value ? gender.value : "");
          setUniversityId(
            graduated_university && graduated_university.key
              ? graduated_university.key
              : ""
          );
          setUniversityName(
            graduated_university && graduated_university.value
              ? graduated_university.value
              : ""
          );
          setGraduatedYear(
            graduated_year && graduated_year.value ? graduated_year.value : ""
          );
          setRegisteredYear(
            registered_year && registered_year.value
              ? registered_year.value
              : ""
          );
          setDataPartition(
            data_partition && data_partition.value ? data_partition.value : ""
          );
          setOrgId(
            affiliated_organization_customer_code &&
              affiliated_organization_customer_code.key
              ? affiliated_organization_customer_code.key
              : ""
          );
          setRepresentativeCode(
            affiliated_organization_customer_code &&
              affiliated_organization_customer_code.value
              ? affiliated_organization_customer_code.value
              : ""
          );
          setDepartmentId(
            affiliated_department && affiliated_department.key
              ? affiliated_department.key
              : ""
          );
          setDepartmentName(
            affiliated_department && affiliated_department.value
              ? affiliated_department.value
              : ""
          );
          setRoleId(role && role.key ? role.key : "");
          setRoleName(role && role.value ? role.value : "");
          setUniversityRoleId(
            university_role && university_role.key ? university_role.key : ""
          );
          setUniversityRoleName(
            university_role && university_role.value
              ? university_role.value
              : ""
          );
          setHospitalStatus(
            hospital_owner &&
              hospital_owner.value &&
              hospital_owner.value === "Yes"
              ? 1
              : 0
          );
          setIsUltmarcPharmacist(
            ultmarc_pharmacist_flag && ultmarc_pharmacist_flag.value === "Yes"
              ? 1
              : 0
          );
          setRemarks(remarks && remarks.value ? remarks.value : "");
          path === "personRequestResubmit" &&
            setReApplicationCode(
              ultmarc_reception_code &&
                ultmarc_reception_code.response_from_ultmarc
                ? ultmarc_reception_code.response_from_ultmarc
                : ""
            );
          path === "personRequestEdit" &&
            setReApplicationCode(
              ultmarc_reception_code && ultmarc_reception_code.value
                ? ultmarc_reception_code.value
                : ""
            );
        }
      });
    }
      } catch (error) {
        console.error("Error fetching person data:", error);
        setIsLoading(false);
      }
    }
    
    fetchPersonData();
  }, []);

  useEffect(() => {
    setPersonNotice(
      props.language === "en"
        ? sessionStorage.getItem("en_person_notice")
        : sessionStorage.getItem("jp_person_notice")
    );
  }, [props.language]);

  const goBack = () => {
    setTimeout(() => {
      window.history.forward();
    }, 0);
  };

  const getCustomerTypeCode = async (id) => {
    let body = {
      customer_type_id: id,
    };
    await getCustomerCode(body).then((res) => {
      setCustomerCode(res && res.data);
    });
  };

  const handleCloseMessage = () => {
    setShowMessage(false);
  };

  /*** 
  @purpose : Handle customer type
  @Parameter : {value}
  **/
  const handleCustomerType = async (value) => {
    setCustomerTypeId(value?.value ?? null);
    setCustomerTypeName(value?.label ?? null);
  };

  /*** 
  @purpose : Handle close
  @Parameter : {}
  **/
  const handleClose = () => {
    setActive("esearch-box lg-box");
  };

  /*** 
  @purpose : Validate get representative code form
  @Parameter : {}
  **/
  const validateCustomerCodeForm = () => {
    let isFormValid = true;
    let pattern = new RegExp(/[<(.|\n*?)>]/);
    let regex = new RegExp(
      /[一-龠]+|[ぁ-ゔ]+|[ァ-ヴー]+|[a-zA-Z0-9]+|[ａ-ｚＡ-Ｚ０-９]+[々〆〤]+/
    );
    let errors = {
      kanjiCustomerName: "",
      kanaCustomerName: "",
    };

    if (kanjiCustomerName && !regex.test(kanjiCustomerName))
      errors.kanjiCustomerName = "errorMessages.VALID_KANJI_CUSTOMER_NAME";
    else if (kanjiCustomerName && pattern.test(kanjiCustomerName))
      errors.kanjiCustomerName = "errorMessages.VALID_KANJI_CUSTOMER_NAME";
    else errors.kanjiCustomerName = "";

    if (kanaCustomerName && !regex.test(kanaCustomerName))
      errors.kanaCustomerName = "errorMessages.VALID_KANA_CUSTOMER_NAME";
    else if (kanaCustomerName && pattern.test(kanaCustomerName))
      errors.kanaCustomerName = "errorMessages.VALID_KANA_CUSTOMER_NAME";
    else errors.kanaCustomerName = "";

    if (errors.kanjiCustomerName !== "" || errors.kanaCustomerName !== "") {
      isFormValid = false;
    } else {
      isFormValid = true;
    }
    setCustomerErrors(errors);
    return isFormValid;
  };

  /*** 
  @purpose : Get org representative list
  @Parameter : {}
  **/
  const getOrgRepresentativeList = async () => {
    if (validateCustomerCodeForm()) {
      setLoading(true);
      let body = {
        unifiedCustomerCode: orgUnifiedCustomerCode,
        customerNameLocal: kanjiCustomerName,
        personNameKana: kanaCustomerName,
      };
      await getOrganizationInquiryList(body).then((response) => {
        if (response.success === true && response.data.length > 0) {
          setRepresentativeList(response.data);
          setLoading(false);
          setNoData(false);
        }
        if (
          (response.success === true && response.data.length === 0) ||
          response.success === false
        ) {
          setLoading(false);
          setNoData(true);
          setRepresentativeList([]);
        }
      });
    }
  };

  /*** 
  @purpose : Handle birth place change
  @Parameter : {value}
  **/
  const handleBirthPlaceChange = (value) => {
    setPrefectureID(value?.value ?? null);
    setPrefecture(value?.label ?? null);
  };

  /*** 
  @purpose : Handle association change
  @Parameter : {value}
  **/
  const handleAssociationChange = (value) => {
    setAssociationId(value?.value ?? null);
    setAssociationName(value?.label ?? null);
  };

  /*** 
  @purpose : Handle university change
  @Parameter : {value}
  **/
  const handleUniversityChange = (value) => {
    setUniversityId(value?.value ?? null);
    setUniversityName(value?.label ?? null);
  };

  /*** 
  @purpose : Handle graduated year
  @Parameter : {date}
  **/
  const handleGraduatedYear = (date) => {
    setGraduatedYearDate(date);
    var date = new Date(date);
    setGraduatedYear(date.getFullYear().toString());
  };

  /*** 
  @purpose : Handle registered year
  @Parameter : {date}
  **/
  const handleRegisteredYear = (date) => {
    setRegisteredYearDate(date);
    var date = new Date(date);
    setRegisteredYear(date.getFullYear().toString());
  };

  /*** 
  @purpose : Handle dropdown
  @Parameter : {}
  **/
  const handleDropdown = () => {
    setDropdownList([...dropdownList, { speciality: "" }]);
  };

  /*** 
  @purpose : Handle speciality
  @Parameter : {value}
  **/
  const handleSpeciality = (value) => {
    if (value.length <= 5) {
      setSpecialities(value);
    } else {
      setSpecialities(specialities);
    }
  };

  /*** 
  @purpose : Handle speciality
  @Parameter : {value}
  **/
  const handleGenderChange = (value) => {
    if (value) {
      setGenderId(value.value);
      setGenderName(value.label);
    } else {
      setGenderId("");
      setGenderName("");
    }
  };

  /*** 
  @purpose : Handle department
  @Parameter : {value}
  **/
  const handleDepartment = (value) => {
    setDepartmentId(value?.value ?? null);
    setDepartmentName(value?.label ?? null);
  };

  /*** 
  @purpose : Handle role
  @Parameter : {value}
  **/
  const handleRole = (value) => {
    setRoleId(value?.value ?? null);
    setRoleName(value?.label ?? null);
  };

  /*** 
  @purpose : Handle university role
  @Parameter : {value}
  **/
  const handleUniversityRole = (value) => {
    setUniversityRoleId(value?.value ?? null);
    setUniversityRoleName(value?.label ?? null);
  };

  /*** 
  @purpose : Handle hospital status
  @Parameter : {e}
  **/
  const handleHospitalStatus = (e) => {
    let status = e.target.checked;
    setHospitalStatus(status ? 1 : 0);
  };

  /*** 
  @purpose : Handle hospital status
  @Parameter : {e}
  **/
  const handleUltmarcPharmacistFlag = (e) => {
    let status = e.target.checked;
    setIsUltmarcPharmacist(status === true ? 1 : 0);
  };

  /*** 
  @purpose : Go to next step
  @Parameter : {}
  **/
  const next = () => {
    if (validateForm()) {
      let list = [];
      for (let i = 0; i < newSpecialityList.length; i++) {
        specialityList.map((sp) => {
          sp.options.map((s) => {
            if (s.value == newSpecialityList[i]) {
              list.push(s.label);
            }
          });
        });
      }
      setSelectedSpecialities(list);
      setCurrent(current + 1);
    }
  };

  /*** 
  @purpose : Go to previous step
  @Parameter : {}
  **/
  const prev = () => {
    setCurrent(current - 1);
    setNewSpecialityList([]);
  };

  /*** 
  @purpose : Handle sorting
  @Parameter : {}
  **/
  const handleRepresentativeSort = (col) => {
    let list = [...representativeList];
    list.sort((a, b) => {
      if (`a.${col}` < `b.${col}`) {
        return -1;
      }
      if (`a.${col}` > `b.${col}`) {
        return 1;
      }
      return 0;
    });
    setRepresentativeList(list);
  };

  const [checkState, setcheckState] = useState(false)

  /*** 
  @purpose : Handle affiliated code
  @Parameter : {item}
  **/
  const handleAffiliatedCode = (item) => {
    /* setRepresentativeCode(item.legacyUnifiedCustomerCode);   /* SAKAMOTO: AHDD-5861 Ultmarc code change */
    setRepresentativeCode(item.unifiedCustomerCode);            /* SAKAMOTO: AHDD-5861 Ultmarc code change */
    setRepresentativeName(item.facilityName);
   setcheckState(true)
   setOrgId(item.orgCustID);
  };

  /*** 
  @purpose : Validate person attribute change form
  @Parameter : {}
  **/
  const validateForm = () => {
    let isFormValid = true;
    let pattern = new RegExp(/[<.|\n*?>]/);
    let kanaRegex = new RegExp(/^[ｦ-ﾟ -~]+$/);
    let errors = {
      customerType: "",
      kanjiFacilityName: "",
      kanaFacilityName: "",
      specialities: "",
      remarks: "",
    };

    if (customerTypeId === "")
      errors.customerType = "errorMessages.PROVIDE_CUSTOMER_TYPE";

    if (kanjiFacilityName && pattern.test(kanjiFacilityName))
      errors.kanjiFacilityName = "errorMessages.VALID_KANJI_NAME";
    else if (kanjiFacilityName === "")
      errors.kanjiFacilityName = "errorMessages.PROVIDE_KANJI_FACILITY_NAME";
    else errors.kanjiFacilityName = "";

    if (kanaFacilityName && kanaRegex.test(kanaFacilityName) === false)
      errors.kanaFacilityName = "errorMessages.VALID_KANA_NAME";
    else errors.kanaFacilityName = "";

    // Check if role or university role is "研修医" (resident doctor)
    const isResidentDoctor = roleName === RESIDENT_DOCTOR_ROLE || universityRoleName === RESIDENT_DOCTOR_ROLE;

    // Only require specialities for doctors who are not residents
    if (customerCode === "100" && !isResidentDoctor) {
      if (specialities.length === 0)
        errors.specialities = "errorMessages.PROVIDE_SPECIALITY";
    }

    if (pattern.test(remarks)) errors.remarks = "errorMessages.VALID_REMARKS";

    if (path === "personAttributeChange") {
      if (customerCode === "100") {
        if (
          errors.kanjiFacilityName !== "" ||
          errors.kanaFacilityName !== "" ||
          errors.specialities !== "" ||
          errors.remarks !== ""
        ) {
          isFormValid = false;
        } else {
          isFormValid = true;
        }
      } else {
        if (errors.kanjiFacilityName !== "" || errors.kanaFacilityName !== "") {
          isFormValid = false;
        } else {
          isFormValid = true;
        }
      }
    } else if (
      path === "personRequestResubmit" ||
      path === "personRequestEdit"
    ) {
      if (submissionType === "New") {
        if (customerCode === "100") {
          if (
            errors.kanjiFacilityName !== "" ||
            errors.kanaFacilityName !== "" ||
            errors.specialities !== "" ||
            errors.representativeCode
          ) {
            isFormValid = false;
          } else {
            isFormValid = true;
          }
        } else {
          if (
            errors.kanjiFacilityName !== "" ||
            errors.kanaFacilityName !== ""
          ) {
            isFormValid = false;
          } else {
            isFormValid = true;
          }
        }
      } else if (submissionType === "Change") {
        if (customerCode === "100") {
          if (
            errors.kanjiFacilityName !== "" ||
            errors.kanaFacilityName !== "" ||
            errors.specialities !== ""
          ) {
            isFormValid = false;
          } else {
            isFormValid = true;
          }
        } else {
          if (
            errors.kanjiFacilityName !== "" ||
            errors.kanaFacilityName !== ""
          ) {
            isFormValid = false;
          } else {
            isFormValid = true;
          }
        }
      }
    }
    setErrors(errors);
    return isFormValid;
  };

  const [ultraMacFlagValue, setUltraMacFlagValue] = useState(false)
  useEffect(() => {
    if(customerCode === "120" && representativeCode.substring(0,2) ==='00' ){
      setUltraMacFlagValue(true)
    } else {
      setUltraMacFlagValue(false)
    }
  }, [customerCode,unifiedCustomerCode,checkState,representativeCode,representativeName,orgId]);

  /*** 
  @purpose : Person attribute change
  @Parameter : {}
  **/
  const perAttributeChange = async () => {
    setResultLoading(true);
    let list = [];
    specialities.map((sp) => list.push(sp.value));
    if (path === "personAttributeChange") {
      let body = {
        perCustID: personId,
        unified_customer_code: unifiedCustomerCode,
        customer_type: customerTypeId,
        customer_name_kanji: kanjiFacilityName,
        customer_name_kana: kanaFacilityName,
        gender: genderId,
        birth_place: prefectureID,
        doctor_pharmacist_association: associationId,
        graduated_university: universityId,
        graduated_year: graduatedYear,
        registered_year: registeredYear,
        specialities: list,
        ultmarc_pharmacist_flag: ultraMacFlagValue,
        hospital_owner: hospitalStatus,
        remarks: remarks,
      };
      await personAttributeChange(body).then((response) => {
        if (response.success === true) {
          setResultLoading(false);
          setRequestSubmissionId(response.id);
          setCurrent(current + 1);
        } else if (response.success === false) {
          setResultLoading(false);
          setShowMessage(true);
        }
      });
    } else if (path === "personRequestResubmit") {
      if (submissionType === "New") {
        let body = {
          submission_id: submissionId,
          submission_data: "person_customer",
          submission_type: submissionType,
          unified_customer_code: unifiedCustomerCode,
          customer_id: customerId,
          customer_type: customerTypeId,
          data_partition: dataPartition,
          customer_name_kanji: kanjiFacilityName,
          customer_name_kana: kanaFacilityName,
          gender: genderId,
          birth_place: prefectureID,
          doctor_pharmacist_association: associationId,
          graduated_university: universityId,
          graduated_year: graduatedYear,
          registered_year: registeredYear,
          specialities: list,
          affiliated_organization_customer: orgId,
          affiliated_department: departmentId,
          role: roleId,
          university_role: universityRoleId,
          hospital_owner: hospitalStatus,
          ultmarc_pharmacist_flag: ultraMacFlagValue,
          remarks: remarks,
          reapplication_acceptance_code: reApplicationCode,
        };
        await resubmitChangeRequest(body).then((response) => {
          if (response.success === true) {
            setResultLoading(false);
            setRequestSubmissionId(response.id);
            setCurrent(current + 1);
          } else if (response.success === false) {
            setResultLoading(false);
            setShowMessage(true);
          }
        });
      } else {
        let body = {
          submission_id: submissionId,
          submission_data: "person_customer",
          submission_type: submissionType,
          unified_customer_code: unifiedCustomerCode,
          customer_id: customerId,
          customer_type: customerTypeId,
          data_partition: dataPartition,
          customer_name_kanji: kanjiFacilityName,
          customer_name_kana: kanaFacilityName,
          gender: genderId,
          birth_place: prefectureID,
          doctor_pharmacist_association: associationId,
          graduated_university: universityId,
          graduated_year: graduatedYear,
          registered_year: registeredYear,
          specialities: list,
          hospital_owner: hospitalStatus,
          ultmarc_pharmacist_flag: ultraMacFlagValue,
          remarks: remarks,
          reapplication_acceptance_code: reApplicationCode,
        };
        await resubmitChangeRequest(body).then((response) => {
          if (response.success === true) {
            setResultLoading(false);
            setRequestSubmissionId(response.id);
            setCurrent(current + 1);
          } else if (response.success === false) {
            setResultLoading(false);
            setShowMessage(true);
          }
        });
      }
    } else if (path === "personRequestEdit") {
      if (submissionType === "New") {
        let body = {
          submission_id: submissionId,
          submission_data: "person_customer",
          submission_type: submissionType,
          unified_customer_code: unifiedCustomerCode,
          customer_id: customerId,
          customer_type: customerTypeId,
          data_partition: dataPartition,
          customer_name_kanji: kanjiFacilityName,
          customer_name_kana: kanaFacilityName,
          gender: genderId,
          birth_place: prefectureID,
          doctor_pharmacist_association: associationId,
          graduated_university: universityId,
          graduated_year: graduatedYear,
          registered_year: registeredYear,
          specialities: list,
          affiliated_organization_customer: orgId,
          affiliated_department: departmentId,
          role: roleId,
          university_role: universityRoleId,
          hospital_owner: hospitalStatus,
          ultmarc_pharmacist_flag: ultraMacFlagValue,
          remarks: remarks,
          reapplication_acceptance_code: reApplicationCode,
        };
        await editChangeRequest(body).then((response) => {
          if (response.success === true) {
            setResultLoading(false);
            setRequestSubmissionId(response.id);
            setCurrent(current + 1);
          } else if (response.success === false) {
            setResultLoading(false);
            setShowMessage(true);
          }
        });
      } else {
        let body = {
          submission_id: submissionId,
          submission_data: "person_customer",
          submission_type: submissionType,
          unified_customer_code: unifiedCustomerCode,
          customer_id: customerId,
          customer_type: customerTypeId,
          data_partition: dataPartition,
          customer_name_kanji: kanjiFacilityName,
          customer_name_kana: kanaFacilityName,
          gender: genderId,
          birth_place: prefectureID,
          doctor_pharmacist_association: associationId,
          graduated_university: universityId,
          graduated_year: graduatedYear,
          registered_year: registeredYear,
          specialities: list,
          affiliated_organization_customer: orgId,
          affiliated_department: departmentId,
          role: roleId,
          university_role: universityRoleId,
          hospital_owner: hospitalStatus,
          ultmarc_pharmacist_flag: ultraMacFlagValue,
          remarks: remarks,
          reapplication_acceptance_code: reApplicationCode,
        };
        await editChangeRequest(body).then((response) => {
          if (response.success === true) {
            setResultLoading(false);
            setRequestSubmissionId(response.id);
            setCurrent(current + 1);
          } else if (response.success === false) {
            setResultLoading(false);
            setShowMessage(true);
          }
        });
      }
    }
  };

  /*** 
  @purpose : Change route
  @Parameter : {e, page}
  **/
  const changeRoute = (e, page) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    navigate(page);
  };

  /*** 
  @purpose : Handle select
  @Parameter : {}
  **/
  const handleSelect = () => {
    setActive("esearch-box lg-box active");
  };

  const steps = [
    {
      title: `${lang("organizationDetails.custNewChangeRequest")}`,
      content: (
        <React.Fragment>
          <div className="submission-box card shadow-card">
            <div className="card-body">
              <div className="sb-row">
                <div className="sb-label">
                  {lang("customerRequestStatus.submissionType")}
                </div>
                <div className="sb-content">
                  {path === "personAttributeChange" && (
                    <a href="#">{lang("errorMessages.change")}</a>
                  )}
                  {path === "personRequestResubmit" && (
                    <a href="#">{submissionType ? submissionType : ""}</a>
                  )}
                  {path === "personRequestEdit" && (
                    <a href="#">{submissionType ? submissionType : ""}</a>
                  )}
                </div>
              </div>
              <div className="sb-row">
                <div className="sb-label">
                  {lang("customerRequestStatus.submissionData")}
                </div>
                <div className="sb-content">
                  <a href="#">{lang("customerRequestStatus.personCustomer")}</a>
                </div>
              </div>
            </div>
          </div>
          <div className="warning-box card">
            <div className="card-body">
              {/* <div className="warning-icon">
                <img src="images/warning.svg" alt="warning" />
              </div> */}
              {/* <h4>{lang("organizationDetails.noticeLabel")}</h4> */}
              <p
                className="notice"
                dangerouslySetInnerHTML={{ __html: personNotice }}
              />
            </div>
          </div>
          <div className="card shadow-card">
            <div className="card-header">
              <h4>{lang("organizationDetails.custNewChangeRequest")}</h4>
            </div>
            <div className="card-body">
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("organizationDetails.submissionID")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      value={submissionId ? submissionId : ""}
                      readOnly
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.unifiedCustomerCode")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      value={
                        /* legacyUnifiedCustomerCode     /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                        /*  ? legacyUnifiedCustomerCode  /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                        unifiedCustomerCode              /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                          ? unifiedCustomerCode          /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                          : ""
                      }
                      readOnly
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.customerType")}
                    {submissionType === "New" && (
                      <span className="danger">*</span>
                    )}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      className="ant-select"
                      options={customerTypeList}
                      placeholder={customerTypeName ? customerTypeName : ""}
                      onChange={handleCustomerType}
                      disabled={true}
                      showSearch={
                        customerTypeList && customerTypeList.length > 0
                          ? true
                          : false
                      }
                      labelInValue={true}
                      optionFilterProp="label"
                    />
                    {submissionType === "New" && errors.customerType && (
                      <p className="error-text">
                        {lang(`${errors.customerType}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("PersonMenu.kanjiName")}
                    <span className="danger">*</span>
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      value={kanjiFacilityName ? kanjiFacilityName : ""}
                      maxLength="100"
                      onChange={(e) => setKanjiFacilityName(e.target.value)}
                    />
                    {errors.kanjiFacilityName && (
                      <p className="error-text">
                        {lang(`${errors.kanjiFacilityName}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("PersonMenu.kanaName")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      value={kanaFacilityName ? kanaFacilityName : ""}
                      maxLength="100"
                      onChange={(e) => setKanaFacilityName(e.target.value)}
                    />
                    {errors.kanaFacilityName && (
                      <p className="error-text">
                        {lang(`${errors.kanaFacilityName}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("PersonMenu.gender")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      className="ant-select"
                      options={genderList}
                      onChange={handleGenderChange}
                      placeholder={genderName ? genderName : "(Gender)"}
                      allowClear={genderId ? true : false}
                      value={{ value: genderId, label: genderName }}
                      showSearch={
                        genderList && genderList.length > 0 ? true : false
                      }
                      labelInValue={true}
                      optionFilterProp="label"
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("PersonMenu.birthPlace")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      className="ant-select"
                      options={prefectureList}
                      placeholder={prefecture ? prefecture : ""}
                      onChange={handleBirthPlaceChange}
                      allowClear={prefectureID ? true : false}
                      value={{ value: prefectureID, label: prefecture }}
                      showSearch={
                        prefectureList && prefectureList.length > 0
                          ? true
                          : false
                      }
                      labelInValue={true}
                      optionFilterProp="label"
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("PersonMenu.dentistAssociation")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      className="ant-select"
                      options={prefectureList}
                      placeholder={associationName ? associationName : ""}
                      allowClear={associationId ? true : false}
                      value={{ value: associationId, label: associationName }}
                      onChange={handleAssociationChange}
                      showSearch={
                        prefectureList && prefectureList.length > 0
                          ? true
                          : false
                      }
                      labelInValue={true}
                      optionFilterProp="label"
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("PersonMenu.graduatedUniversity")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      className="ant-select"
                      options={universityList}
                      placeholder={universityName ? universityName : ""}
                      allowClear={universityId ? true : false}
                      value={{ value: universityId, label: universityName }}
                      onChange={handleUniversityChange}
                      showSearch={
                        universityList && universityList.length > 0
                          ? true
                          : false
                      }
                      labelInValue={true}
                      optionFilterProp="label"
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("PersonMenu.graduatedYear")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <DatePicker
                      selected={graduatedYearDate}
                      value={graduatedYear}
                      className="form-control"
                      onChange={(date) => handleGraduatedYear(date)}
                      showYearPicker
                      dateFormat="yyyy"
                      yearItemNumber={9}
                      isClearable
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("PersonMenu.registeredYear")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <DatePicker
                      className="form-control"
                      selected={registeredYearDate}
                      value={registeredYear}
                      onChange={(date) => handleRegisteredYear(date)}
                      showYearPicker
                      dateFormat="yyyy"
                      yearItemNumber={9}
                      isClearable
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.specialities")}
                    {customerCode === "100" &&
                     roleName !== RESIDENT_DOCTOR_ROLE &&
                     universityRoleName !== RESIDENT_DOCTOR_ROLE && (
                      <span className="danger">*</span>
                    )}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      className="ant-select"
                      value={specialities}
                      mode="multiple"
                      options={specialityList}
                      onChange={handleSpeciality}
                      showSearch={
                        specialityList && specialityList.length > 0
                          ? true
                          : false
                      }
                      labelInValue={true}
                      optionFilterProp="label"
                    />
                    <p>Please select upto 5 specialities</p>
                    {customerCode === "100" && errors.specialities && (
                      <p className="error-text">
                        {lang(`${errors.specialities}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              {(path === "personRequestEdit" ||
                path === "personRequestResubmit") &&
                submissionType === "New" && (
                  <>
                    <div className="horizon-form">
                      <div className="custom-3">
                        <label>
                          {lang("OrganizationMenu.affiliatedName")}
                          {submissionType === "New" && (
                            <span className="danger">*</span>
                          )}
                        </label>
                      </div>
                      <div className="custom-9">
                        <div className="mrs-main">
                          <div className="mrs-box">
                            <label className="select-mrs">
                              {representativeCode}
                            </label>
                            <div>
                              {representativeCode && (
                                <button
                                  className="cancel"
                                  onClick={() => {
                                    setRepresentativeCode("");
                                    setRepresentativeName("");
                                    setcheckState(false);
                                  }}
                                >
                                  X
                                </button>
                              )}
                              <button
                                className="btn btn-primary"
                                onClick={handleSelect}
                              >
                                {lang("Buttons.select")}
                              </button>
                            </div>
                          </div>
                          <div className={active}>
                            <div className="row">
                              <div className="col-md-9">
                                <div className="form-group inline-input lg">
                                  <label>
                                    {lang(
                                      "organizationDetails.unifiedCustomerCode"
                                    )}
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={orgUnifiedCustomerCode}
                                    onChange={(e) =>
                                      setOrgUnifiedCustomerCode(e.target.value)
                                    }
                                  />
                                </div>
                                <div className="form-group inline-input lg">
                                  <label>
                                    {lang(
                                      "organizationDetails.kanjiCustomerName"
                                    )}
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={kanjiCustomerName}
                                    onChange={(e) =>
                                      setKanjiCustomerName(e.target.value)
                                    }
                                  />
                                  {submissionType === "New" &&
                                    customerErrors.kanjiCustomerName && (
                                      <p className="error-text">
                                        {lang(
                                          `${customerErrors.kanjiCustomerName}`
                                        )}
                                      </p>
                                    )}
                                </div>
                                <div className="form-group inline-input lg">
                                  <label>
                                    {lang(
                                      "organizationDetails.kanaCustomerName"
                                    )}
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={kanaCustomerName}
                                    onChange={(e) =>
                                      setKanaCustomerName(e.target.value)
                                    }
                                  />
                                  {customerErrors.kanaCustomerName && (
                                    <p className="error-text">
                                      {lang(
                                        `${customerErrors.kanaCustomerName}`
                                      )}
                                    </p>
                                  )}
                                </div>
                              </div>
                              <div className="col-12 mb-4">
                                <button
                                  className="btn btn-primary"
                                  onClick={getOrgRepresentativeList}
                                >
                                  {lang("Buttons.apply")}
                                </button>
                              </div>
                            </div>
                            {representativeList.length > 0 && (
                              <>
                                <p className="record-total">
                                  {lang(
                                    "territoryDefinitionMaintenance.totalRecords"
                                  )}{" "}
                                  - {representativeList.length}
                                </p>
                                <div className="table-responsive esearch-table">
                                  <table
                                    className="table"
                                    aria-describedby="table"
                                  >
                                    <thead>
                                      <tr>
                                        <th scope="col"></th>
                                        <th
                                          scope="col"
                                          onClick={() =>
                                            handleRepresentativeSort(
                                              "unifiedCustomerCode"
                                            )
                                          }
                                        >
                                          <div className="cursor-pointer">
                                            {lang(
                                              "organizationDetails.unifiedCustomerCode"
                                            )}
                                            <em className="bx bxs-sort-alt"></em>
                                          </div>
                                        </th>
                                        <th
                                          scope="col"
                                          onClick={() =>
                                            handleRepresentativeSort(
                                              "facilityName"
                                            )
                                          }
                                        >
                                          <div className="cursor-pointer">
                                            {lang(
                                              "organizationDetails.kanjiCustomerName"
                                            )}
                                            <em className="bx bxs-sort-alt"></em>
                                          </div>
                                        </th>
                                        <th
                                          scope="col"
                                          onClick={() =>
                                            handleRepresentativeSort(
                                              "customerTypeName"
                                            )
                                          }
                                        >
                                          <div className="cursor-pointer">
                                            {lang(
                                              "organizationDetails.kanaCustomerName"
                                            )}
                                            <em className="bx bxs-sort-alt"></em>
                                          </div>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {representativeList &&
                                        representativeList.map((item, index) => {
                                          return (
                                            <tr key={index}>
                                              <td>
                                                <button
                                                  className="btn btn-primary"
                                                  onClick={() =>
                                                    handleAffiliatedCode(item)
                                                  }
                                                >
                                                  Select
                                                </button>
                                              </td>
                                              <td>
                                                {item.unifiedCustomerCode}
                                              </td>
                                              <td>{item.facilityName}</td>
                                              <td>{item.customerTypeName}</td>
                                            </tr>
                                          );
                                        })}
                                    </tbody>
                                  </table>
                                </div>
                              </>
                            )}
                            {representativeList &&
                              representativeList.length < 1 &&
                              loading === true && (
                                <Spinner animation="border" />
                              )}
                            <div className="mt-2 text-right">
                              <button
                                className="btn btn-primary"
                                onClick={handleClose}
                              >
                                {lang("Buttons.close")}
                              </button>
                            </div>
                          </div>
                          <p className="error-text">
                            {personErrors.representativeCode}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="horizon-form">
                      <div className="custom-3">
                        <label>
                          {lang("organizationDetails.affiliatedDepartment")}
                        </label>
                      </div>
                      <div className="custom-9">
                        <div className="form-group">
                          <Select
                            className="ant-select"
                            options={departmentList}
                            onChange={handleDepartment}
                            showSearch={
                              departmentList && departmentList.length > 0
                                ? true
                                : false
                            }
                            placeholder={
                              departmentName
                                ? departmentName
                                : "(Department Name)"
                            }
                            labelInValue={true}
                            optionFilterProp="label"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="horizon-form">
                      <div className="custom-3">
                        <label>{lang("organizationDetails.role")}</label>
                      </div>
                      <div className="custom-9">
                        <div className="form-group">
                          <Select
                            className="ant-select"
                            options={roleList}
                            onChange={handleRole}
                            showSearch={
                              roleList && roleList.length > 0 ? true : false
                            }
                            placeholder={roleName ? roleName : "(Role)"}
                            labelInValue={true}
                            optionFilterProp="label"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="horizon-form">
                      <div className="custom-3">
                        <label>
                          {lang("organizationDetails.universityRole")}
                        </label>
                      </div>
                      <div className="custom-9">
                        <div className="form-group">
                          <Select
                            className="ant-select"
                            options={roleList}
                            onChange={handleUniversityRole}
                            showSearch={
                              roleList && roleList.length > 0 ? true : false
                            }
                            placeholder={
                              universityRoleName
                                ? universityRoleName
                                : "(University Role)"
                            }
                            labelInValue={true}
                            optionFilterProp="label"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="horizon-form with-textfield mt-2">
                      <div className="custom-3">
                        <label>
                          {lang("organizationDetails.hospitalOwner")}
                        </label>
                      </div>
                      <div className="custom-9">
                        <div className="custom-checkbox mb-0">
                          <input
                            type="checkbox"
                            id="owner2"
                            name="table-checkbox"
                            checked={hospitalStatus === 0 ? false : true}
                            onChange={(e) => handleHospitalStatus(e)}
                          />
                          <label className="mb-0" htmlFor="owner2"></label>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              {customerCode === "120" && (
                <div className="horizon-form with-textfield mt-2">
                  <div className="custom-3">
                    <label>{lang("PersonMenu.ultmarcPharmacistFlag")}</label>
                  </div>
                  <div className="custom-9">
                    <div className="custom-checkbox mb-0">
                      <input
                        type="checkbox"
                        id="pharmacistFlag"
                        name="table-checkbox"
                        disabled
                        checked={ultraMacFlagValue}
                        onChange={(e) => handleUltmarcPharmacistFlag(e)}
                      />
                      <label className="mb-0" htmlFor="pharmacistFlag"></label>
                    </div>
                  </div>
                </div>
              )}
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("organizationDetails.remarks")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <textarea
                      className="form-control"
                      value={remarks || ""}
                      onChange={(e) => setRemarks(e.target.value)}
                      maxLength="200"
                    ></textarea>
                    {errors.remarks && (
                      <p className="error-text">{lang(`${errors.remarks}`)}</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.reapplicationAcceptanceCode")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      value={reApplicationCode}
                      readOnly
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ),
    },
    {
      title: `${lang("organizationDetails.confirmationLabel")}`,
      content: (
        <React.Fragment>
          <div className="card shadow-card">
            <div className="card-header">
              <h4>{lang("organizationDetails.confirmationLabel")}</h4>
            </div>
            <div className="card-body">
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("customerRequestStatus.submissionType")}</label>
                </div>
                <div className="custom-9">
                  {path === "personAttributeChange" && (
                    <div className="value-label color-dark">
                      {lang("errorMessages.change")}
                    </div>
                  )}
                  {path === "personRequestResubmit" && (
                    <div className="value-label color-dark">
                      {submissionType ? submissionType : ""}
                    </div>
                  )}
                  {path === "personRequestEdit" && (
                    <div className="value-label color-dark">
                      {submissionType ? submissionType : ""}
                    </div>
                  )}
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("customerRequestStatus.submissionData")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {lang("customerRequestStatus.personCustomer")}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("organizationDetails.submissionID")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label">
                    {submissionId ? submissionId : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.unifiedCustomerCode")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {/* legacyUnifiedCustomerCode ? legacyUnifiedCustomerCode : "" /* SAKAMOTO: AHDD-5861 Ultmarc code change */}
                    {unifiedCustomerCode ? unifiedCustomerCode : ""                /* SAKAMOTO: AHDD-5861 Ultmarc code change */}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.customerType")}
                    {submissionType === "New" && (
                      <span className="danger">*</span>
                    )}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {customerTypeName ? customerTypeName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("OrganizationMenu.kanjiFacilityName")}
                    <span className="danger">*</span>
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {kanjiFacilityName ? kanjiFacilityName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("OrganizationMenu.kanaFacilityName")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {kanaFacilityName ? kanaFacilityName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("PersonMenu.gender")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {genderName ? genderName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("PersonMenu.birthPlace")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {prefecture ? prefecture : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("PersonMenu.dentistAssociation")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {associationName ? associationName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("PersonMenu.graduatedUniversity")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {universityName ? universityName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("PersonMenu.graduatedYear")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {graduatedYear ? graduatedYear : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("PersonMenu.registeredYear")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {registeredYear ? registeredYear : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.specialities")}
                    {customerCode === "100" &&
                     roleName !== RESIDENT_DOCTOR_ROLE &&
                     universityRoleName !== RESIDENT_DOCTOR_ROLE && (
                      <span className="danger">*</span>
                    )}
                  </label>
                </div>
                <div className="custom-9">
                  {specialities &&
                    specialities.map((sp, index) => {
                      return (
                        <div key={index} className="value-label color-dark">{sp.label}</div>
                      );
                    })}
                </div>
              </div>
              {(path === "personRequestResubmit" ||
                path === "personRequestEdit") &&
                submissionType === "New" && (
                  <>
                    <div className="horizon-form with-textfield">
                      <div className="custom-3">
                        <label>
                          {lang("OrganizationMenu.affiliatedName")}
                          <span className="danger">*</span>
                        </label>
                      </div>
                      <div className="custom-9">
                        <div className="value-label color-dark">
                          {representativeCode
                            ? representativeName +
                              "(" +
                              representativeName +
                              ")"
                            : ""}
                        </div>
                      </div>
                    </div>
                    <div className="horizon-form with-textfield">
                      <div className="custom-3">
                        <label>
                          {lang("organizationDetails.affiliatedDepartment")}
                        </label>
                      </div>
                      <div className="custom-9">
                        <div className="value-label color-dark">
                          {departmentName ? departmentName : ""}
                        </div>
                      </div>
                    </div>
                    <div className="horizon-form with-textfield">
                      <div className="custom-3">
                        <label>{lang("organizationDetails.role")}</label>
                      </div>
                      <div className="custom-9">
                        <div className="value-label color-dark">
                          {roleName ? roleName : ""}
                        </div>
                      </div>
                    </div>
                    <div className="horizon-form with-textfield">
                      <div className="custom-3">
                        <label>
                          {lang("organizationDetails.universityRole")}
                        </label>
                      </div>
                      <div className="custom-9">
                        <div className="value-label color-dark">
                          {universityRoleName ? universityRoleName : ""}
                        </div>
                      </div>
                    </div>
                    <div className="horizon-form with-textfield">
                      <div className="custom-3">
                        <label>
                          {lang("organizationDetails.hospitalOwner")}
                        </label>
                      </div>
                      <div className="custom-9">
                        <div className="custom-checkbox">
                          <input
                            type="checkbox"
                            id="check1"
                            name="table-checkbox"
                            value={hospitalStatus}
                            checked={hospitalStatus === 0 ? false : true}
                            disabled
                          />
                          <label className="mb-0" htmlFor="check1"></label>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              {customerCode == "120" && (
                <div className="horizon-form with-textfield">
                  <div className="custom-3">
                    <label>{lang("PersonMenu.ultmarcPharmacistFlag")}</label>
                  </div>
                  <div className="custom-9">
                    <div className="custom-checkbox">
                      <input
                        type="checkbox"
                        id="check2"
                        name="table-checkbox"
                        value={ultraMacFlagValue}
                        checked={ultraMacFlagValue}
                        disabled
                      />
                      <label className="mb-0" htmlFor="check2"></label>
                    </div>
                  </div>
                </div>
              )}
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("organizationDetails.remarks")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">{remarks}</div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.reapplicationAcceptanceCode")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label">{reApplicationCode}</div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ),
    },
    {
      title: `${lang("organizationDetails.completedLabel")}`,
      content: (
        <React.Fragment>
          <div className="submission-box card shadow-card">
            <div className="card-header">
              <h4>{lang("organizationDetails.completedLabel")}</h4>
            </div>
            <div className="card-body">
              <p className="mb-3">
                {lang("errorMessages.REQUEST_SUBMITTED")}
                <span className="subm-title">
                  {lang("organizationDetails.submissionID")} :{" "}
                  {requestSubmissionId}
                </span>
              </p>
              <p className="mb-3">
                {lang("errorMessages.VIEW_SUBMISSION_STATUS")}
                <a
                  className="link"
                  onClick={(e) => {
                    changeRoute(e, "/customerRequestStatus");
                  }}
                >
                  {" "}
                  {lang("Menu.customerRequestStatus")}
                </a>
              </p>
            </div>
          </div>
        </React.Fragment>
      ),
    },
  ];

  return (
    <Home>
            {maintenance ? (
        <Maintenance />
      ) : (
      <>
      <Breadcrumb routes={routes} />
      {isLoading ? (
        <Spinner animation="border" />
      ) : (
        <>
          <Steps current={current}>
            {steps.map((item, index) => (
              <Step key={index} title={item.title} />
            ))}
          </Steps>
          <div className="steps-content horizon-form-lg">
            {steps[current].content}
          </div>
          <div className="steps-action">
            {resultLoading && <Spinner animation="border" />}
            {current > 0 && current < 2 && (
              <Button
                style={{ margin: "0 12px" }}
                onClick={() => prev()}
                disabled={resultLoading}
              >
                {lang("Buttons.previous")}
              </Button>
            )}
            {current < 2 && (
              <Button
                type="primary"
                disabled={resultLoading}
                onClick={() => (current < 1 ? next() : perAttributeChange())}
              >
                {current < 1
                  ? `${lang("Buttons.next")}`
                  : `${lang("Buttons.submit")}`}
              </Button>
            )}
          </div>
          <Modal
            size="md"
            className="withdraw-modal"
            show={showMessage}
            onHide={handleCloseMessage}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <div className="warning-msg">
                {lang("errorMessages.REQUEST_NOT_SUBMITTED")}
              </div>
              <div className="buttons-group">
                <button
                  className="btn btn-primary"
                  onClick={handleCloseMessage}
                >
                  {lang("Buttons.ok")}
                </button>
              </div>
            </Modal.Body>
          </Modal>
        </>
      )}
          </>)}
    </Home>
  );
}

const mapStateToProps = (state) => {
  return {
    details: state.organizationCustomer.orgDetails,
    language: state.organizationCustomer.language,
  };
};

export default connect(mapStateToProps, { getPersonCustomerDetails })(
  PersonAttributeChange
);
